import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import { combineReducers, SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

import { omdApi } from './api';
import { authReducer } from './auth/reducer';
import { reducerConfig } from './config/reducer';
import { driverSalaryAdjustmentsReducer } from './driverSalaryAdjustments/reducer';
import { nomenclatureReducer } from './nomenclature/reducer';
import { nomenclatureCustomNameReducer } from './nomenclatureCustomName/reducer';
import { reportReducer } from './report/reducer';
import { shiftReducer } from './shift/reducer';

export const rootReducer = combineReducers({
  [omdApi.reducerPath]: omdApi.reducer,
  auth: authReducer,
  config: reducerConfig,
  nomenclature: nomenclatureReducer,
  shift: shiftReducer,
  report: reportReducer,
  driverSalaryAdjustments: driverSalaryAdjustmentsReducer,
  nomenclatureCustomName: nomenclatureCustomNameReducer,
});

export type AppStore = ReturnType<typeof rootReducer>;
export const useSelector: TypedUseSelectorHook<AppStore> = useReduxSelector;

export type RTKResponse = { data?: any; error?: FetchBaseQueryError | SerializedError };
